import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { format } from 'date-fns';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import SectionHeader from 'components/atoms/GefMui/SectionHeader/SectionHeader';
import { defaultDateFormatDateFns } from 'constants/general';
import { getPpzByLogin } from 'features/other/organizationStructureMUI/ppz/selectors';
import { getSellerByLogin } from 'features/other/organizationStructureMUI/seller/selectors';
import { FIELDS } from 'features/views/productionReport/form';
import { joinString } from 'utils/string';

export const Header = ({ formData }) => {
	const seller = useSelector(getSellerByLogin(formData?.seller));
	const ppz = useSelector(getPpzByLogin(formData?.ppz));

	const today = format(new Date(), defaultDateFormatDateFns);
	const orgName = !isNilOrEmpty(ppz) ? ppz : seller;
	const labelName = !isNilOrEmpty(ppz) ? 'ppz' : 'seller';

	const headerText = joinString(' ', [getLabelMessage('producedProductionReport:reportedDate'), today]);

	return (
		<Stack spacing={2}>
			<SectionHeader text={headerText} />
			<Grid container>
				<Grid size={12}>
					<Grid container spacing={2}>
						<Grid size={4}>
							<OutputTextField
								size="small"
								id={!isNilOrEmpty(ppz) ? FIELDS.ppz : FIELDS.seller}
								label={getLabelMessage(`producedProductionReport:${labelName}`)}
								fullWidth
								value={joinString(' ', [orgName.surname, orgName.firstName]).trim()}
								slotProps={{
									inputLabel: {
										shrink: !!getLabelMessage(`producedProductionReport:${labelName}`),
									},
								}}
							/>
						</Grid>
						<Grid size={4}>
							<OutputTextField
								size="small"
								id={!isNilOrEmpty(ppz) ? FIELDS.ppzSellerIn : FIELDS.sellerSellerIn}
								label={getLabelMessage(`producedProductionReport:${labelName}SellerIn`)}
								fullWidth
								value={String(orgName.sellerIn || '')}
								slotProps={{
									inputLabel: {
										shrink: !!getLabelMessage(`producedProductionReport:${labelName}SellerIn`),
									},
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Stack>
	);
};

Header.propTypes = {
	formData: PropTypes.object,
};

export default Header;
